module.exports = __webpack_public_path__ + "img/recognizeImg.56a4362f.png";